import React, { useState } from "react"
import { Collapse } from "@quorumus/plum"
import {
    Container,
    Title,
    ContentWrapper,
} from "QuorumGrassroots/campaign-forms/components/GotvV2Form/components/CollapsibleSection/CollapsibleSection.styles"

export interface CollapsibleSectionProps {
    /** Title displayed in the header */
    title: string
    /** Content to be displayed when expanded */
    children: React.ReactNode
    /** Optional initial open state */
    defaultOpen?: boolean
    /** Optional className for styling */
    className?: string
    /** Optional data-plum-id for tracking */
    "data-plum-id"?: string
}

export const CollapsibleSection = ({
    title,
    children,
    defaultOpen = true,
    className,
    "data-plum-id": dataPlumId,
}: CollapsibleSectionProps) => {
    const [isOpen, setIsOpen] = useState(defaultOpen)

    const handleToggle = () => {
        setIsOpen(!isOpen)
    }

    return (
        <Container className={className}>
            <Collapse in={isOpen} label={<Title>{title}</Title>} onToggle={handleToggle} data-plum-id={dataPlumId}>
                <ContentWrapper>{children}</ContentWrapper>
            </Collapse>
        </Container>
    )
}
